import * as React from 'react';

function ListTriggerIcon({ fill = '#6C7281', ...rest }) {
  return (
 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#06A864" fill="none" stroke="#06A864" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 22H10.5C6.72873 22 4.8431 22 3.67153 20.8284C2.49995 19.6568 2.49997 17.7712 2.5 13.9999L2.50004 9.99993C2.50007 6.22872 2.50008 4.34312 3.67166 3.17156C4.84323 2 6.72883 2 10.5 2H11.4999C15.2712 2 17.1568 2 18.3284 3.17157C19.4999 4.34315 19.4999 6.22876 19.4999 10V11" />
    <path d="M7 7H15M7 12H11.5" />
    <path d="M22 17.5L14 17.5M22 17.5C22 16.7998 20.0057 15.4915 19.5 15M22 17.5C22 18.2002 20.0057 19.5085 19.5 20" />
</svg>
  );
}

export default ListTriggerIcon;